const timeoutSplash = document.querySelector(".js-timeout-splash");
let idleTime = 0;

function openTimeoutSplash() {
    document.body.classList.add("stop-scrolling");
    const splashText = timeoutSplash.querySelector(".js-splash-text");
    const splashImg = timeoutSplash.querySelector(".js-splash-img");
    const openingTl = gsap.timeline();

    openingTl

        .to(timeoutSplash, {
            autoAlpha: 1,
            duration: 0.6,
            delay: 0.3,
            ease: "power3.inOut"
        })

        .to(splashText, {
            autoAlpha: 1,
            duration: 0.6,
            delay: 0.3,
            ease: "power3.inOut"
        })

        .to(splashImg, {
            autoAlpha: 1,
            duration: 0.6,
            delay: -0.3,
            ease: "power1.inOut"
        });
}

function closeTimeoutSplash() {
    document.body.classList.remove("stop-scrolling");
    const splashText = timeoutSplash.querySelector(".js-splash-text");
    const splashImg = timeoutSplash.querySelector(".js-splash-img");
    const closingTl = gsap.timeline();

    closingTl

        .to(splashText, {
            autoAlpha: 0,
            duration: 0.3,
            ease: "power2.inOut"
        })

        .to(splashImg, {
            autoAlpha: 0,
            duration: 0.3,
            delay: -0.3,
            ease: "power2.inOut"
        })

        .to(timeoutSplash, {
            autoAlpha: 0,
            duration: 0.3,
            delay: -0.6,
            ease: "power2.inOut"
        });
}

let idleInterval = setInterval(timerIncrement, 1000);

function resetTimer() {
    idleTime = 0;
    closeTimeoutSplash();
}

function timerIncrement() {

    idleTime = idleTime + 1;

    if (idleTime > 120) {

        openTimeoutSplash();
    }
}

document.addEventListener("mousemove", resetTimer, false);
document.addEventListener("mousedown", resetTimer, false);
document.addEventListener("keypress", resetTimer, false);
document.addEventListener("touchmove", resetTimer, false);
timeoutSplash.addEventListener("click", resetTimer);